<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" title="退款">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item prop="refundmoney" label="退款金额">
                    <el-input v-model="form.refundmoney" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item prop="isqualifications" label="班级学员">
                    <el-radio v-model="form.isqualifications" :label="1">保留资格</el-radio>
                    <el-radio v-model="form.isqualifications" :label="0">取消资格</el-radio>
                </el-form-item>
                <el-form-item prop="refundmemo" label="退款说明">
                    <el-input v-model="form.refundmemo" type="textarea" show-word-limit autosize maxlength="200" placeholder="请输入" clearable></el-input>
                </el-form-item>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" :loading="isLoading" @click="reFundOrder">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { reFundOrder } from '@/api/measApi/transactionManage.js'
export default {
  data() {
    return {
      visible: false,
      form: {
        code: '',
        isqualifications: 1,
        orderno: '',
        refundmemo: '',
        refundmoney: ''
      },
      isLoading: false,
      orgForm: {},
      nowprice: '',
      rules: {
        refundmoney: [
          { required: true, message: '请输入退款金额', trigger: 'blur' }
        ],
        isqualifications: [
          { required: true, message: '请选择班级学员', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleOpen(row) {
      this.orgForm = JSON.parse(JSON.stringify(this.form))
      this.visible = true
      this.form.refundmoney = row.nowprice
      this.nowprice = row.nowprice
      this.form.code = row.code
      this.form.orderno = row.orderno
    },
    reFundOrder() {
      this.$refs.form.validate(validate => {
        if (validate) {
          if (Number(this.form.refundmoney) > Number(this.nowprice)) {
            this.$message.warning('订单支付金额不能超过支付金额')
            return
          }
          this.$confirm(
            '退款前请确认是否给学员转账成功，继续吗？如果取消资格，则取消该班级该学员的学习资格。',
            '提示',
            {
              confirmButtonText: '取消',
              cancelButtonText: '确定',
              type: 'warning',
              customClass: 'measElMessage'
            }
          )
            .then(() => {
              this.isLoading = true
              reFundOrder(this.form).then(res => {
                if (res.code === '000') {
                  this.$message.success(res.msg)
                  this.$emit('saveSuccess')
                  this.isLoading = false
                  this.handleClose()
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消退款'
              })
            })
        }
      })
    },
    handleClose() {
      if (this.isLoading) {
        this.$message.warning('提交数据中，请稍等')
        return
      }
      this.visible = false
      this.form = this.orgForm
      this.$refs.form.clearValidate()
    }
  }
}
</script>

